
import React, { ReactNode } from 'react';

type StepType = {
  number: string;
  title: string;
  description: string;
};

type PhaseLayoutProps = {
  order: number;
  icon: ReactNode;
  title: string;
  description: string;
  steps: StepType[];
  contentLeft?: ReactNode;
  contentRight?: ReactNode;
  reversed?: boolean;
};

export const PhaseLayout = ({ 
  order, 
  icon, 
  title, 
  description, 
  steps, 
  contentLeft, 
  contentRight,
  reversed = false 
}: PhaseLayoutProps) => {
  return (
    <div className="relative">
      <div className="flex flex-col md:flex-row items-center gap-12">
        <div className={`md:w-5/12 order-2 ${reversed ? 'md:order-3' : 'md:order-1'} opacity-0 animate-fade-in`}>
          <div className={reversed ? '' : 'md:text-right'}>
            <h3 className="text-2xl font-semibold mb-3">{title}</h3>
            <p className="text-gray-600 mb-6">
              {description}
            </p>
            
            <div className="space-y-4">
              {steps.map((step, index) => (
                <div key={index} className={`flex items-start ${reversed ? '' : 'md:flex-row-reverse'}`}>
                  <div className={`w-8 h-8 rounded-full ${
                    reversed ? 'bg-teal-100' : 'bg-wamy-100'
                  } flex items-center justify-center flex-shrink-0 mr-3 ${
                    reversed ? '' : 'md:ml-3 md:mr-0'
                  }`}>
                    <span className={`${
                      reversed ? 'text-teal-700' : 'text-wamy-700'
                    } text-sm font-semibold`}>{step.number}</span>
                  </div>
                  <div className={`flex-1 ${reversed ? '' : 'md:text-right'}`}>
                    <h4 className="text-sm font-medium text-gray-800">{step.title}</h4>
                    <p className="text-sm text-gray-600">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="md:w-2/12 flex justify-center order-1 md:order-2">
          <div className="w-16 h-16 rounded-full bg-gradient-to-r from-wamy-600 to-teal-500 flex items-center justify-center shadow-lg z-10">
            {icon}
          </div>
        </div>
        
        <div className={`md:w-5/12 order-3 ${reversed ? 'md:order-1' : 'md:order-3'} opacity-0 animate-fade-in-delay-1`}>
          {contentLeft || contentRight}
        </div>
      </div>
    </div>
  );
};
